import React, { useState, useRef, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import "./CustomHorizontalTable.scss";
import Modal from "../CustomModal/CustomModal";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../routes/routes";
import axiosInstance from "../../services/api/API";
import { ShimmerTable } from "react-shimmer-effects";

const CustomHorizontalTable = ({
  isOpenStatus,
  isADDcomplainTable,
  totalRecords,
  leadPriority,
  isasignLead = false,
  headers,
  data,
  keyMapping,
  itemsPerPage,
  currentPage,
  totalPages,
  onPageChange,
  handleMailFunc,
  isAllocation,
  onEdit = () => {},
  handleraftEdit = () => {},
  onDelete = () => {},
  handleViewButton = () => {},
  handleDelete = () => {},
  handleClaim = () => {},
  handlePriviledges = () => {},
  handleAddLogistics = () => {},
  handleEditButton = () => {},
  onPriviledges,
  onAdd,
  handleClicableRow = () => {},
  onAddSerial = () => {},
  actionToBeTaken = () => {},
  pdfDownLoad = () => {},
  redirectionFunc = () => {},
  tableLoaderShow = false,
  handleDownloadButton = () => {},
  handlePrintInvoice = () => {},
  fetchUnassignedFilterList = () => {},
  fetchUnassignedList = () => {},
}) => {
  const [checkboxState, setCheckboxState] = useState(data?.map(() => false));
  const [assigneeList, setAssigneeList] = useState([]);
  const navigate = useNavigate();
  const [filteredAssigneeList, setFilteredAssigneeList] =
    useState(assigneeList);
  const assignButtonRef = useRef(null);
  const [modalPosition, setModalPosition] = useState({});
  const authToken = localStorage.getItem("authToken");
  const engineer_id = localStorage.getItem("engineer_id");

  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);

  const handleImagePreviewOpen = (imageUrl) => {
    setPreviewImageUrl(imageUrl);
    setIsImagePreviewOpen(true);
  };

  const handleImagePreviewClose = () => {
    setIsImagePreviewOpen(false);
    setPreviewImageUrl(null);
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (pageIndex) => {
    onPageChange(pageIndex);
  };
  const visiblePages = 5; // Number of visible page buttons
  const startPage = Math.max(0, currentPage - Math.floor(visiblePages / 2));

  const endPage = Math.min(totalPages - 1, startPage + visiblePages - 1);

  const getStartIndex = () => {
    return currentPage * itemsPerPage + 1;
  };

  const getEndIndex = () => {
    return Math.min((currentPage + 1) * itemsPerPage, totalRecords);
  };

  const renderHorizontalCell = ({
  header,
  row,
  colIndex,
  keyMapping,
  engineer_id,
  isOpenStatus,
  onEdit,
  handleViewButton,
  onAdd,
  pdfDownLoad,
  handleDelete,
  handleMailFunc,
  handleClaim,
  onPriviledges,
  redirectionFunc,
  handleImagePreviewOpen,
}) => {
  const key = keyMapping?.[header];

  // ---- Action row: render all action icons for this data row ----
  if (header === "Action" && Array.isArray(key)) {
    return (
      <>
        {key.map((action, actionIndex) => {
          const showIcon =
            (row.isgate_pass_done === 1 && action.type === "print") ||
            ["delete","mail","claim","checkclaim","addserial","edit","view","priviledge","printCustomerPurchaseOrder","printInvoice","downloadRiderDetails","invoiceCopy","mailDealer"].includes(action.type) ||
            (action.type === "add" && row.allownewlead) ||
            (action.type === "print" && row.is_complated === "Done") ||
            (action.type === "manageorder" && row.payment_status === "Done") ||
            (action.type === "draftedit" && (row.is_order_accepted === 6 || row.is_order_accepted === 8)) ||
            (action.type === "redirection" && (engineer_id ?? 0) > 0);

          if (!showIcon) return null;

          const onClick = () => {
            if (action.type === "edit" || action.type === "draftedit") onEdit?.(row);
            else if (action.type === "view") handleViewButton?.(row);
            else if (action.type === "add") onAdd?.(row);
            else if (
              ["print","printCustomerPurchaseOrder","manageorder","downloadRiderDetails","invoiceCopy","printInvoice"].includes(action.type)
            ) pdfDownLoad?.(row);
            else if (action.type === "delete") handleDelete?.(row);
            else if (action.type === "mail" || action.type === "mailDealer") handleMailFunc?.(row);
            else if (action.type === "claim" || action.type === "checkclaim") handleClaim?.(row);
            else if (action.type === "priviledge") onPriviledges?.(row);
            else if (action.type === "redirection") redirectionFunc?.(row);
          };

          return (
            <img
              key={actionIndex}
              src={action.icon}
              alt={action.label ?? action.type}
              className="action-icon"
              style={{ gap: 5, marginLeft: 10, cursor: "pointer" }}
              data-tip={action.label}
              data-for={`action-tooltip-${row.id}-${actionIndex}`}
              onClick={(e) => { e.stopPropagation(); onClick(); }}
            />
          );
        })}
      </>
    );
  }

  // ---- Image-type rows ----
  if (header === "Product Image" && row.product_image) {
    return (
      <img
        src={row.product_image}
        alt="Product"
        className="table-image"
        onClick={(e) => { e.stopPropagation(); handleImagePreviewOpen?.(row.product_image); }}
      />
    );
  }

  if (header === "Payment Image" && row.payment_image) {
    return (
      <img
        src={row.payment_image}
        alt="Payment"
        className="table-image"
        style={{ cursor: "pointer" }}
        onClick={(e) => { e.stopPropagation(); window.open(row.payment_image, "_blank"); }}
      />
    );
  }

  if (header === "Image" && row.item_image) {
    return (
      <img
        src={row.item_image}
        alt="Item"
        className="table-image"
        onClick={(e) => { e.stopPropagation(); handleImagePreviewOpen?.(row.item_image); }}
      />
    );
  }

  if (header === "ProductImage" && row.productimage) {
    return (
      <img
        src={row.productimage}
        alt="Product"
        className="table-image"
        onClick={(e) => { e.stopPropagation(); handleImagePreviewOpen?.(row.productimage); }}
      />
    );
  }

  if (header === "Item Image" && row.imagepath) {
    return (
      <img
        src={row.imagepath}
        alt="Item"
        className="table-image"
        onClick={(e) => { e.stopPropagation(); handleImagePreviewOpen?.(row.imagepath); }}
      />
    );
  }

  // ---- Status-style rows ----
  if (header === "Job Status") {
    const v = row[key];
    const cls =
      v === "Done" ? "paymentstatus"
      : v === "Pending" || v === "Rejected" ? "inactiveJobCard"
      : v === "Partial" ? "partial-approved"
      : "";
    return <span className={cls}>{v}</span>;
  }

  if (header === "Claim Status") {
    const v = row[key];
    const cls = v === "Approved" ? "paymentstatus" : v === "Pending" ? "inactive-status" : "rejected-Status";
    return <span className={cls}>{v}</span>;
  }

  if (header === "Status") {
    const v = row[key];
    if (isOpenStatus) {
      return <span className="openStatus">{v}</span>;
    }
    const cls =
      v === "Approved" || v === "Active" || v === "Done" ? "active-status"
      : v === "Pending" ? "inactive-status"
      : v === "Partial Approved" || v === "Partial Delivered" ? "partial-approved"
      : v === "Modified" ? "modified"
      : v === "Hold" ? "holdstatus"
      : v === "View VIN" ? "deliveredStatus"
      : v === "Inactive" ? "rejected-Status"
      : "rejected-Status";
    return <span className={cls}>{v}</span>;
  }

  // ---- Default cell ----
  return row[key] ?? "";
};

  return (
    <>
      {tableLoaderShow ? (
        <ShimmerTable
          mode="custom"
          row={5}
          col={7}
          border={1}
          borderColor={"#374151"}
          rounded={0.25}
          rowGap={16}
          colPadding={[10, 5, 10, 5]}
        />
      ) : (
        <div className="table-container">
          {/* <table 
        //   className="custom-table"
        className="custom-table horizontal-table"
          >
            <thead>
              <tr>
                {headers?.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.map((row, rowIndex) => (
                <tr key={row.id} onClick={() => handleClicableRow(row)}>
                  {headers?.map((header, colIndex) => {
                    const key = keyMapping[header];

                    if (header === "Action") {
                      return (
                        <td
                          key={colIndex}
                          data-tip={row[key]}
                          data-for={`cell-tooltip-${row.id}-${colIndex}`}
                        >
                          {key?.map((action, actionIndex) => (
                            <img
                              key={actionIndex}
                              // src={(row.isgate_pass_done === 1 && action.type === 'print') ? action?.icon:action.type === 'delete'? action?.icon:action.type === 'addserial'? action?.icon:action.type === 'edit'?action.icon :action.type === 'view' ?  action.icon :(action.type === 'add' && row.allownewlead) ?  action.icon:action.type ==='priviledge' ?   action.icon:null }
                              src={
                                // type: "manageorder",
                                row.isgate_pass_done === 1 &&
                                action.type === "print"
                                  ? action?.icon
                                  : action.type === "delete"
                                  ? action?.icon
                                  : action.type === "mail"
                                  ? action?.icon
                                  : action.type === "claim"
                                  ? action?.icon
                                  : action.type === "checkclaim"
                                  ? action?.icon
                                  : action.type === "addserial"
                                  ? action?.icon
                                  : action.type === "edit"
                                  ? action.icon
                                  : action.type === "view"
                                  ? action.icon
                                  : action.type === "add" && row.allownewlead
                                  ? action.icon
                                  : action.type === "priviledge"
                                  ? action.icon
                                  : action.type === "print" &&
                                    row.is_complated === "Done"
                                  ? action.icon
                                  : action.type === "manageorder" &&
                                    row.payment_status === "Done"
                                  ? action.icon
                                  : (action.type === "draftedit" &&
                                      row.is_order_accepted === 6) ||
                                    row.is_order_accepted === 8
                                  ? action.icon
                                  : action.type === "invoiceCopy" &&
                                    row?.attachedStatus === 1
                                  ? action.icon
                                  : action.type === "printCustomerPurchaseOrder"
                                  ? action.icon
                                  : action.type === "printInvoice"
                                  ? action.icon
                                  : action.type === "redirection" &&
                                    engineer_id > 0
                                  ? action.icon
                                  : action.type === "downloadRiderDetails"
                                  ? action.icon
                                  : action.type === "mailDealer"
                                  ? action.icon
                                  : action.type === "priviledge"
                                  ? action.icon
                                  : null
                              }
                              // prividegeIcon
                              // redirection
                              // mailDealer
                              style={{ gap: 5, marginLeft: 10 }}
                              data-tip={action.label}
                              data-for={`action-tooltip-${row.id}-${actionIndex}`}
                              onClick={() => {
                                if (action.type === "edit") {
                                  onEdit(row);
                                  // handleEditButton()
                                } else if (action.type === "view") {
                                  handleViewButton(row);
                                  // handleView(row.id);
                                } else if (action.type === "add") {
                                  onAdd(row);
                                } else if (action.type === "print") {
                                  pdfDownLoad(row);
                                } else if (action.type === "delete") {
                                  handleDelete(row);
                                } else if (action.type === "mail") {
                                  handleMailFunc(row);
                                } else if (action.type === "mailDealer") {
                                  handleMailFunc(row);
                                } else if (action.type === "claim") {
                                  handleClaim(row);
                                } else if (action.type === "checkclaim") {
                                  handleClaim(row);
                                } else if (
                                  action.type === "printCustomerPurchaseOrder"
                                ) {
                                  pdfDownLoad(row);
                                } else if (action.type === "manageorder") {
                                  pdfDownLoad(row);
                                } else if (
                                  action.type === "downloadRiderDetails"
                                ) {
                                  pdfDownLoad(row);
                                } else if (action.type === "invoiceCopy") {
                                  pdfDownLoad(row);
                                } else if (action.type === "draftedit") {
                                  onEdit(row);
                                } else if (action.type === "priviledge") {
                                  onPriviledges(row);
                                } else if (action.type === "redirection") {
                                  redirectionFunc(row);
                                }
                              }}
                              className="action-icon"
                            />
                          ))}
                        </td>
                      );
                    }

                    if (header === "Product Image" && row.product_image) {
                      console.log("imagedata", row.product_image);

                      return (
                        <td key={colIndex}>
                          <img
                            src={row?.product_image}
                            alt="Product"
                            className="table-image"
                            onClick={() =>
                              handleImagePreviewOpen(row.product_image)
                            }
                          />
                        </td>
                      );
                    }

                    // if (header === "Payment Image" && row.payment_image) {
                    //   console.log("imagedata",row.payment_image);

                    //   return (
                    //     <td key={colIndex}>
                    //       <img
                    //         src={row?.payment_image}
                    //         alt="Product"
                    //         className="table-image"
                    //         onClick={() =>
                    //           handleImagePreviewOpen(row.payment_image)
                    //         }

                    //       />
                    //     </td>
                    //   );
                    // }

                    if (header === "Payment Image" && row.payment_image) {
                      console.log("imagedata", row.payment_image);

                      return (
                        <td key={colIndex}>
                          <img
                            src={row?.payment_image}
                            alt="Product"
                            className="table-image"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              window.open(row.payment_image, "_blank")
                            }
                          />
                        </td>
                      );
                    }

                    if (header === "Image" && row.item_image) {
                      console.log("imagedata", row.item_image);

                      return (
                        <td key={colIndex}>
                          <img
                            src={row?.item_image}
                            alt="Product"
                            className="table-image"
                            onClick={() =>
                              handleImagePreviewOpen(row.item_image)
                            }
                          />
                        </td>
                      );
                    }

                    if (header === "ProductImage" && row.productimage) {
                      console.log("imagedata", row.productimage);

                      return (
                        <td key={colIndex}>
                          <img
                            src={row?.productimage}
                            alt="Product"
                            className="table-image"
                            onClick={() =>
                              handleImagePreviewOpen(row.productimage)
                            }
                          />
                        </td>
                      );
                    }

                    if (header === "Item Image" && row.imagepath) {
                      console.log("imagedata", row.productimage);

                      return (
                        <td key={colIndex}>
                          <img
                            src={row?.imagepath}
                            alt="Product"
                            className="table-image"
                            onClick={() =>
                              handleImagePreviewOpen(row.imagepath)
                            }
                          />
                        </td>
                      );
                    }

                    if (header === "Job Status") {
                      return (
                        <td key={colIndex} className="statusheader">
                          <span
                            className={
                              row[key] === "Done"
                                ? "paymentstatus"
                                : row[key] === "Pending" ||
                                  row[key] === "Rejected"
                                ? "inactiveJobCard"
                                : row[key] === "Pending"
                                ? "partial-approved"
                                : ""
                            }
                          >
                            {row[key]}
                          </span>
                        </td>
                      );
                    }

                    if (header === "Claim Status") {
                      return (
                        <td key={colIndex} className="statusheader">
                          <span
                            className={
                              row[key] === "Approved"
                                ? "paymentstatus"
                                : row[key] === "Pending"
                                ? "inactive-status"
                                : "rejected-Status"
                            }
                          >
                            {row[key]}
                          </span>
                        </td>
                      );
                    }
                    if (header === "Status") {
                      return (
                        <td key={colIndex} className="statusheader">
                          <span
                            className={
                              row[key] === "Approved" || row[key] === "Active"
                                ? "paymentstatus"
                                : row[key] === "Pending"
                                ? "inactive-status"
                                : row[key] === "Partial Approved"
                                ? "partial-approved"
                                : row[key] === "Partial Delivered"
                                ? "partial-approved"
                                : row[key] === "Modified"
                                ? "modified"
                                : row[key] === "Hold"
                                ? "holdstatus"
                                : row[key] === "View VIN"
                                ? "deliveredStatus"
                                : row[key] === "Inactive"
                                ? "rejected-Status"
                                : "rejected-Status"
                            }
                          >
                            {row[key]}
                          </span>
                        </td>
                      );
                    }

                    if (header === "Status") {
                      return (
                        <td key={colIndex} className="statusheader">
                          {isOpenStatus ? (
                            <span
                              className={
                                row[key] === "Active"
                                  ? "openStatus"
                                  : "openStatus"
                              }
                            >
                              {row[key]}
                            </span>
                          ) : (
                            <span
                              className={
                                row[key] === "Active"
                                  ? "active-status"
                                  : row[key] === "Done"
                                  ? "active-status"
                                  : "inactive-status"
                              }
                            >
                              {row[key]}
                            </span>
                          )}
                        </td>
                      );
                    }
                    return <td key={colIndex}>{row[key]}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table> */}

          <div className="table-container">
  <table className="custom-table horizontal-table">
    <tbody>
      {headers?.map((header, headerIndex) => (
        <tr key={headerIndex}>
          {/* left-side header cell */}
          <th className="row-header">{header}</th>

          {/* one cell per original data row */}
          {data?.map((row, colIndex) => (
            <td key={`${row.id ?? colIndex}-${headerIndex}`} onClick={() => handleClicableRow?.(row)}>
              {renderHorizontalCell({
                header,
                row,
                colIndex,
                keyMapping,
                engineer_id,
                isOpenStatus,
                // handlers you already have:
                onEdit,
                handleViewButton,
                onAdd,
                pdfDownLoad,
                handleDelete,
                handleMailFunc,
                handleClaim,
                onPriviledges,
                redirectionFunc,
                handleImagePreviewOpen,
              })}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
</div>

        </div>
      )}
      {!isADDcomplainTable && (
        <div className="footer-table-counts">
          <div className="totalDataCounts">
            {totalRecords > 0
              ? `Showing ${getStartIndex()} to ${getEndIndex()} of Total ${totalRecords} Records`
              : "No records found"}
          </div>
          <div className="pagination">
            <FaChevronLeft
              onClick={handlePreviousPage}
              className={
                currentPage === 0
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
            <div className="pagination-btns">
              {startPage > 0 && (
                <span
                  onClick={() => handlePageClick(0)}
                  className="pagination-btn"
                >
                  1
                </span>
              )}
              {startPage > 1 && <span className="pagination-btn">...</span>}
              {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                <span
                  key={startPage + index}
                  onClick={() => handlePageClick(startPage + index)}
                  className={
                    currentPage === startPage + index
                      ? "pagination-btn pagination-active"
                      : "pagination-btn"
                  }
                >
                  {startPage + index + 1}
                </span>
              ))}
              {endPage < totalPages - 2 && (
                <span className="pagination-btn">...</span>
              )}
              {endPage < totalPages - 1 && (
                <span
                  onClick={() => handlePageClick(totalPages - 1)}
                  className="pagination-btn"
                >
                  {totalPages}
                </span>
              )}
            </div>
            <FaChevronRight
              onClick={handleNextPage}
              className={
                currentPage === totalPages - 1
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
          </div>
        </div>
      )}
      {isImagePreviewOpen && (
        <Modal
          isOpen={isImagePreviewOpen}
          handleClose={handleImagePreviewClose}
          className="image-preview-modal"
        >
          <img
            src={previewImageUrl}
            alt="Preview"
            style={{ height: "500px", width: "800px", objectFit: "contain" }}
            className="preview-image"
          />
        </Modal>
      )}
    </>
  );
};

CustomHorizontalTable.propTypes = {
  headers: PropTypes?.arrayOf(PropTypes.string).isRequired,
  data: PropTypes?.arrayOf(PropTypes.object).isRequired,
  keyMapping: PropTypes.object.isRequired,
  itemsPerPage: PropTypes.number,
  isAllocation: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
};

CustomHorizontalTable.defaultProps = {
  itemsPerPage: 10,
  isAllocation: false,
};

export default CustomHorizontalTable;
